<div class="pop-up" id="dismiss-popup">
    <div class="top-row">
        <div class="form-heading">Dismiss This Action</div>
        <img class="hover-pointer" src="assets/close-icon.svg" alt="exit-icon" (click)="exitCover()">
    </div>
    <div class="content-box">
        <div class="question-text">
            Why did you dismiss the "{{recName}}" action?
        </div>
        <textarea title="Dismiss Reason" placeholder="Enter your reason here" class="dismissTextarea"
            [(ngModel)]="dismissalReason" [ngClass]="{'error' : formSubmitted && !dismissalReason}"
            required></textarea>
        <div *ngIf="formSubmitted && !dismissalReason" class="error">Please fill out this field.</div>
    </div>
    <div class="bottom-row">
        <div class="cancel hover-pointer" (click)="exitCover()">Cancel</div>
        <div class="submit hover-pointer" (click)="submitDismissal()">Submit</div>
    </div>
</div>